import React, { useState, useEffect, useRef } from 'react';
import { FaTimes, FaEdit } from 'react-icons/fa';

const EditBasketModal = ({ basket, onClose, onSave }) => {
  const [name, setName] = useState(basket.name);
  const [description, setDescription] = useState(basket.description || '');
  const nameInputRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ name, description });
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 transition-opacity duration-300"
      onClick={onClose}
    >
      <div
        className="bg-neutral-50 rounded-xl shadow-xl max-w-md w-full m-4 transition-all duration-300 transform scale-100 opacity-100 border-2 border-neutral-900"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-neutral-900 flex items-center">
              <FaEdit className="mr-2 text-cranberry-700" />
              Edit Basket
            </h2>
            <button
              onClick={onClose}
              className="text-cranberry-700 hover:text-cranberry-600 transition-colors duration-200"
            >
              <FaTimes size={24} />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-neutral-900 mb-2">
                Basket Name
              </label>
              <input
                type="text"
                id="name"
                ref={nameInputRef}
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-4 py-2 rounded-xl border-2 border-neutral-900 focus:border-cranberry-700 focus:ring-0 focus:outline-none transition-all duration-200"
                required
              />
            </div>
            <div>
              <label htmlFor="description" className="block text-sm font-medium text-neutral-900 mb-2">
                Description (optional)
              </label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full px-4 py-2 rounded-xl border-2 border-neutral-900 focus:border-cranberry-700 focus:ring-0 focus:outline-none transition-all duration-200"
                rows="3"
              />
            </div>
            <div className="flex justify-end space-x-4 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 bg-white text-neutral-900 rounded-xl border-2 border-neutral-900 font-medium hover:bg-neutral-50 transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-cranberry-700 text-white rounded-xl border-2 border-neutral-900 font-medium hover:bg-cranberry-600 transition-colors duration-200"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditBasketModal;
